import { NavLinks } from '@iveco-ti/iveco-ds'
import { ShieldBan } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'

import { Toast } from '../components/Toast'
import { ROUTES } from '../constants/routes'
import { usePermissions } from '../hooks/usePermissions'

export function SettingsLayout() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { cannot } = usePermissions()

  const handleNavigate = (route: string) => {
    navigate(route)
  }

  if (cannot('access', 'Settings')) {
    toast(Toast, {
      toastId: 'settings_access_denied',
      data: {
        type: 'danger',
        icon: ShieldBan,
        title: t('access_denied.title'),
        description: t('access_denied.description'),
      },
    })

    return <Navigate to={ROUTES.PANEL.NEWS} replace />
  }

  return (
    <>
      <NavLinks.Root>
        <p className="text-lg text-brand-900 font-semibold mr-8">
          {t('settings_layout.title')}
        </p>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.SETTINGS.GENERAL)}
          active={pathname === ROUTES.SETTINGS.GENERAL}
        >
          {t('settings_layout.menus.general')}
        </NavLinks.Link>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.SETTINGS.GENERIC_CONTENT)}
          active={pathname === ROUTES.SETTINGS.GENERIC_CONTENT}
        >
          {t('settings_layout.menus.generic_content')}
        </NavLinks.Link>
      </NavLinks.Root>

      <Outlet />
    </>
  )
}
